import { useState } from "react";

export default function QuoteForm({ productName, onClose }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const manrope = { fontFamily: "'Manrope', sans-serif" };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Veuillez entrer votre email.");
      return;
    }

    try {
      const response = await fetch("https://formspree.io/f/mwpwoylw", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          product: productName,
          email,
          message,
        }),
      });

      if (response.ok) {
        setSubmitted(true);
        setError("");
      } else {
        setError("Erreur lors de l'envoi. Réessayez plus tard.");
      }
    } catch (err) {
      setError("Erreur lors de l'envoi. Réessayez plus tard.");
    }
  };

  return (
    // Overlay
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="p-8 bg-white rounded-xl shadow-lg w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {submitted ? (
          <div className="text-center animate-fadeIn min-h-10">
             <h2 className="text-2xl font-bold mb-1 text-black" style={{ fontFamily: "'Clash Display', sans-serif" }}>Merci !</h2>
          <p  className="text-base sm:text-lg md:text-p lg:text-p mb-6 mt-2 max-w-[700px]"
            style={manrope}>
              Votre demande pour <strong>{productName}</strong> a été envoyée avec succès.
            </p>
            <button
              onClick={onClose}
            className="px-4 py-2 bg-transparent border-2 text-lg border-[#158DC1] text-[#158DC1] rounded-[15px] hover:bg-[#158DC1] hover:text-white transition"
   >
              Fermer
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="text"
              value={productName}
              readOnly
              placeholder="Produit"
              className="border rounded-md px-4 py-3 bg-gray-100 cursor-not-allowed"
            />

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Votre email"
              className="border rounded-md px-4 py-3"
            />

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Ajoutez des détails supplémentaires si nécessaire"
              rows={5}
              className="border rounded-md px-4 py-3"
            />

            {error && <p className="text-red-500">{error}</p>}

            <button
              type="submit"
              className="mt-2 px-6 py-3 bg-[#158DC1] text-white rounded-[15px] hover:bg-white hover:text-[#158DC1] border border-[#158DC1] transition"
            >
              Envoyer
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
